import { render, staticRenderFns } from "./ViewPDD.vue?vue&type=template&id=ec4ebc8e"
import script from "./ViewPDD.vue?vue&type=script&lang=js"
export * from "./ViewPDD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports